// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"f3a54115","233":"c14a038d","369":"4673c587","777":"d85915b3","936":"87f2b81a"}[chunkId] + ".js";
};